"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNft = void 0;
function isNft(assetType) {
    return assetType.assetClass === "ERC1155"
        || assetType.assetClass === "ERC721"
        || assetType.assetClass === "ERC1155_LAZY"
        || assetType.assetClass === "ERC721_LAZY";
}
exports.isNft = isNft;
